'use client';
import React from 'react';
import WelcomeSlider from './WelcomeSlider';
import WelcomeLifestyle from './WelcomeLifestyle';
import WelcomeLuxury from './WelcomeLuxury';
import WelcomeAbout from './WelcomeAbout';
import GardeniaContainer from '../GardeniaContainer';
import cn from './style.module.scss';

export default function GardeniaLaunchWelcome(props: any) {
  const { t } = props;
  return (
    <section
      className={cn.launchGRDWelcome}
      style={{
        backgroundImage: `url(${props.waterBgImg.url})`,
      }}
    >
      <div className={cn.welcomeGRDBlock}>
        <WelcomeAbout t={t} aboutBgImg={props.aboutBgImg} />
        <WelcomeLifestyle t={t} lifeStyleBannerImg={props.lifeStyleBannerImg} />
        <GardeniaContainer>
          <WelcomeSlider slideImages={props.slideImages} />
          <WelcomeLuxury t={t} />
        </GardeniaContainer>
      </div>
    </section>
  );
}
